const ActionType = {
  GET_BRANCH_STATS: 'dashboard/get-branch-stats',
  GET_BRANCH_DEVICES_BY_STATE: 'dashboard/get-branch-devices-by-state',
}

export default ActionType
